@if (statusText()) {
  <div class="status-content">
    {{ _cleanedText() }}
  </div>
} @else {
  <div class="status-content">
    {{ _wordings._library.chat.waitingForResponse() }}
  </div>
}
